import React from 'react';
import { useImageEditorContext } from '../context/ImageEditorContext';
import { ActionButtons } from './ActionButtons';

export const EditorFooter: React.FC = () => {
    const {
        copy,
        isBusy,
        isResetVisible,
        isUploading,
        onApply,
        onClose,
        onReset,
        name,
    } = useImageEditorContext();
    return (
        <div className="modal-actions">
                <ActionButtons
                    copy={copy}
                    editorName={name}
                    isBusy={isBusy}
                    isResetVisible={isResetVisible && !isUploading}
                    isUploading={isUploading}
                    onApply={onApply}
                    onClose={onClose}
                    onReset={onReset}
                />
            </div>
    );
};
